export default "<div class='ds-page'>\r\n    <div #content></div>\r\n</div>"